<template>
  <div
    class="post-list-item"
    v-observe-visibility="{
      callback: (isVisible, entry) => visibilityChanged(isVisible, entry),
      once: true,
      throttle: 1000,
    }"
  >
    <div class="brand-column">
      <brand-info :post="post" :brand="post.node.brand" :feed-events="feedEvents" />

      <post-content
        :created-at="post.node.createdAt"
        :body="post.node.postContent.body"
        :promo-code="post.node.postContent.promo_code"
        :link="post.node.link"
      />
    </div>

    <div class="post-column">
      <post-image-with-product-carousel
        :img-id="post.node.id"
        :img-src="$utils.optimizedFeedImageUrl(post.node.media.croppedUrl)"
        :post-index="index"
        :post="post"
        :product-tags="post.node.media.productTags"
        :feed-events="feedEvents"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/sass/base/_vars.scss";
@import "@/assets/sass/base/_mixins.scss";

.post-list-item {
  display: flex;
  border-top: 1px solid $secondaryGrey;
  padding-block: 24px;
  margin-top: 24px;

  @include respond-to("small") {
    flex-direction: column;

    .brand-column,
    .post-column {
      width: 100% !important;
      margin-inline: 0 !important;
    }

    .brand-column {
      margin-bottom: 24px;
    }
  }

  .brand-column,
  .post-column {
    flex: 1;
    width: calc(50% - 24px);
  }

  .brand-column {
    margin-right: 12px;
  }
  .post-column {
    margin-left: 12px;
  }
}
</style>

<script>
import ChatButtonById from "../../components/shared/chatButtonById/chatButtonById";
import InlineSvg from "vue-inline-svg";
import FollowButton from "./TheFollowButton";
import PostCaption from "./PostCaption";
import BrandInfo from "./BrandInfo";
import PostContent from "./PostContent";
import PostImageWithProductCarousel from "@/views/TheDiscoveryFeed/PostImageWithProductCarousel.vue";
import PostActions from "./PostActions";
import PostLink from "./PostLink";
import BrandValuesList from "./BrandValuesList";

export default {
  components: {
    ChatButtonById,
    PostImageWithProductCarousel,
    InlineSvg,
    FollowButton,
    PostCaption,
    PostActions,
    PostLink,
    BrandValuesList,
    BrandInfo,
    PostContent,
  },
  props: {
    post: {
      type: Object,
    },
    index: {
      type: Number,
      default: 0,
    },
    visibilityChanged: {
      type: Function,
    },
    feedEvents: {
      type: Object,
    },
    followButtonClicked: {
      type: Function,
    },
    unfollowButtonClicked: {
      type: Function,
    },
    productTagsRevealed: {
      type: Function,
    },
    productTagCtaClicked: {
      type: Function,
    },
  },
};
</script>
